import { ref } from 'vue';

export type ToastVariant = 'success' | 'error' | 'info' | 'warning';

export interface ToastItem {
  id: number;
  message: string;
  type: ToastVariant;
  duration: number;
  title?: string;
}

interface ToastOptions {
  type?: ToastVariant;
  duration?: number;
  title?: string;
}

// Singleton reactive state shared across all usages
const toasts = ref<ToastItem[]>([]);

let idCounter = 0;

export function useCustomToast() {
  const showToast = (message: string, options: ToastOptions = {}) => {
    const { type = 'success', duration = 3000, title } = options;
    const id = ++idCounter;

    const toast: ToastItem = { id, message, type, duration, title };
    toasts.value.push(toast);

    setTimeout(() => {
      dismissToast(id);
    }, duration);

    return id;
  };

  const dismissToast = (id: number) => {
    const index = toasts.value.findIndex(t => t.id === id);
    if (index > -1) {
      toasts.value.splice(index, 1);
    }
  };

  return {
    toasts,
    showToast,
    dismissToast,
  };
}
